export default {
  label: {
    notes: 'Label of edit thresholds action for visualisation',
    message: 'Edit thresholds',
  },
  dialog: {
    header: {
      notes: 'Header in edit signal intervals dialog',
      message: 'Edit thresholds',
    },
  },
};
